var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChristmasSnow = function SvgChristmasSnow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "aria-hidden": "true",
    vectorEffect: "non-scaling-stroke",
    viewBox: "-0.75 -0.75 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M.703 21.14a13.1 13.1 0 0 1 8.698-.77l3.903 1.012a12.9 12.9 0 0 0 8.493-.7v0m0-5.916a10.24 10.24 0 0 0-8.862.627c-1.813 1.023-1.95 1.11-2.453 1.34M4.219 9.14l-2.813 4.22h1.64L.704 16.874h7.031l-2.343-3.516h1.64zm0 7.735v3.237M16.875 3.516l-2.813 4.218h1.641L13.36 11.25h7.032l-2.344-3.516h1.64zm0 7.734v2.858"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M1.055 1.406a.352.352 0 1 1 0-.703m0 .703a.352.352 0 1 0 0-.703m0 7.735a.352.352 0 1 1 0-.704m0 .704a.352.352 0 1 0 0-.704m4.922-2.812a.352.352 0 1 1 0-.703m0 .703a.352.352 0 1 0 0-.703m4.218 4.921a.352.352 0 0 1 0-.703m0 .703a.352.352 0 0 0 0-.703m1.407-7.031a.352.352 0 0 1 0-.703m0 .703a.352.352 0 0 0 0-.703m9.14.703a.352.352 0 0 1 0-.703m0 .703a.352.352 0 0 0 0-.703"
  })));
};
export default SvgChristmasSnow;